import { reducers, getState } from 'redux/core'


/**
 * Adds link item to breadcrumbs array and returns it's index
 *
 * @param {object} link
 * @param {string} link.to
 * @param {string|object} link.title
 *
 * @returns {number}
 */
const addLink = (link) => {
  const { models: { breadcrumbs } } = getState()

  const index = breadcrumbs.length

  reducers.models.breadcrumbs.set([ ...breadcrumbs, link ])

  return index
}

/**
 * Adds links array to breadcrumbs array and returns first item's index
 *
 * @param {array} links
 *
 * @returns {number}
 */
const addLinks = (links) => {
  const { models: { breadcrumbs } } = getState()

  const index = breadcrumbs.length

  reducers.models.breadcrumbs.set([ ...breadcrumbs, ...links ])

  return index
}

/**
 * Removes links starting from given index
 *
 * @param linkIndex
 */
const removeLinksFromIndex = (linkIndex) => {
  const { models: { breadcrumbs } } = getState()

  if (linkIndex >= breadcrumbs.length) {
    return
  }

  breadcrumbs.splice(linkIndex)

  reducers.models.breadcrumbs.set([ ...breadcrumbs ])
}


export default {
  addLink,
  addLinks,
  removeLinksFromIndex,
}
